import { render } from "./UnitInfo_content_reefer.vue?vue&type=template&id=6b5ab01a&scoped=true"
import script from "./UnitInfo_content_reefer.vue?vue&type=script&lang=js"
export * from "./UnitInfo_content_reefer.vue?vue&type=script&lang=js"

import "./UnitInfo_content_reefer.vue?vue&type=style&index=0&id=6b5ab01a&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6b5ab01a"]])

export default __exports__